import SchoolsContainer from './components/SchoolsContainer';
import SchoolsListContainer from './components/List/SchoolsListContainer';
import SchoolDetailsContainer from './components/Details/SchoolDetailsContainer';
import './assets/scss/main.css';

export {SchoolsListContainer, SchoolDetailsContainer};

export default SchoolsContainer;


// WEBPACK FOOTER //
// ./src/features/Schools/index.js